<template>
  <div>
    <form @submit.prevent="createUpdateCharges">
      <modal v-show="isModalVisible" @close="closeModal" footer>
        <template v-slot:title>
          <h5>Create Transfer Charge</h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="status">Type</label> <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="charge.type"
            >
              <option value="" selected disabled>Please Select...</option>
              <option value="inter-bank" class="mb-2">Inter Bank</option>
              <option value="intra-bank" class="mb-2">
                Intra Bank
              </option>
              <option value="cashout">Cashout</option>
            </select>
          </div>
          <div class="form-group">
            <label for="medium">Medium</label>
            <select name="medium" class="form-control" v-model="charge.medium">
              <option value="" selected disabled>Please Select</option>
              <option value="terminal">Terminal POS</option>
              <option value="account">Account</option>
            </select>
          </div>
          <div class="form-group">
            <label for="medium">Rate</label>
            <select name="medium" class="form-control" v-model="charge.rate">
              <option value="" selected disabled>Please Select</option>
              <option value="flat">Flat</option>
              <option value="percentage">Percentage</option>
            </select>
          </div>
          <div class="form-group">
            <label for="title">Minimum Amount</label>
            <input
              type="text"
              class="form-control"
              placeholder="Minimum Amount"
              name="title"
              @keypress="isNumber($event)"
              v-model="charge.min"
            />
          </div>
          <div class="form-group">
            <label for="title">Maximum Amount</label>
            <input
              type="text"
              placeholder="Maximum Amount"
              @keypress="isNumber($event)"
              class="form-control"
              name="title"
              v-model="charge.max"
            />
          </div>
          <div class="form-group">
            <label for="title">Cap</label>
            <input
              type="text"
              class="form-control"
              placeholder="Cap Amount"
              name="title"
              @keypress="isNumber($event)"
              v-model="charge.cap"
            />
          </div>
          <div class="form-group">
            <label for="title">Amount Charge</label>
            <input
              type="text"
              placeholder="Transaction Charge"
              class="form-control"
              @keypress="isNumber($event)"
              name="title"
              v-model="charge.amount"
            />
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="loading || !formIsValid"
          >
            <span class="custom-loader" v-if="loading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;"
                >Please wait...</span
              >
            </span>
            <span v-else>
              {{ charge.id ? "Update Charge Level" : "Create Charge Level" }}
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Charges Settings ready...</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Transfer Charges Settings</h1>
        </div>
        <div class="col-auto">
          <button
            v-if="permissions.includes('create-transfer-charge')"
            class="button button--outline text-uppercase"
            @click="openModal"
          >
            Add Charge
          </button>
        </div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h4 class="card-title">Transfer Charges Settings</h4>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="charges"
              :fields="fields"
              :items-per-page="small ? 10 : 5"
              pagination
              sorter
              tableFilter
            >
              <template #updated_at="{item}">
                <td class="table--action-mobile">
                  {{ item.updated_at | date }}
                </td>
              </template>
              <template #created_at="{item}">
                <td class="table--action-mobile">
                  {{ item.created_at | date }}
                </td>
              </template>
              <template #action="{item}">
                <td class="table--action-mobile">
                  <button
                    v-if="permissions.includes('update-transfer-charge')"
                    class="button btn-success"
                    style="background-color: #0bc681;"
                    @click="showUpdateModal(item)"
                  >
                    Update
                  </button>
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import ErrorService from "../../services/error.service";
import Swal from "sweetalert2";
import CDataTable from "../../components/CDataTable.vue";
const fields = [
  "type",
  "medium",
  "amount",
  "min",
  "max",
  "cap",
  "rate",
  "action"
];
export default {
  name: "ChargesSettingsComponent",
  props: {
    terminal_id: {
      type: [String, Number],
      required: false,
      default: ""
    }
  },
  components: {
    CDataTable
  },
  data() {
    return {
      fields,
      charges: [],
      small: true,
      charge: {
        type: "",
        amount: "",
        rate: "",
        medium: "",
        min: "",
        cap: "",
        max: ""
      },
      loading: false,
      pageLoading: false,
      isModalVisible: false
    };
  },
  computed: {
    formIsValid() {
      return (
        this.charge.type !== "" &&
        this.charge.amount !== "" &&
        this.charge.medium !== "" &&
        this.charge.min !== "" &&
        this.charge.max !== ""
      );
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    resetCharge() {
      this.charge = {
        type: "",
        amount: "",
        rate: "",
        medium: "",
        min: "",
        cap: "",
        max: ""
      };
    },
    showUpdateModal(item) {
      this.charge = Object.assign({}, item);
      this.isModalVisible = true;
    },
    openModal() {
      this.resetCharge();
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      this.resetCharge();
    },
    async getCharges() {
      console.log(this.terminal_id);
      try {
        this.pageLoading = true;
        const response = await ApiService.get(
          `settings/transfer-charges?terminal_id=${this.terminal_id}`
        );

        this.charges = response.data.data;
        this.pageLoading = false;
      } catch (error) {
        console.log(error);
        this.pageLoading = false;
      }
    },
    async createUpdateCharges() {
      if (this.slug !== "") {
        this.charge = {
          ...this.charge,
          terminal_id: this.terminal_id
        };
      }
      try {
        console.log(this.charge);
        console.log(this.terminal_id);
        this.loading = true;
        const response = await ApiService.post(
          "settings/create-transfer-charge",
          this.charge
        );
        this.loading = false;
        this.closeModal();
        Swal.fire({
          title: "Success",
          text: response.data.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        this.getCharges();
      } catch (error) {
        this.isModalVisible = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        this.loading = false;
      }
    }
  },
  mounted() {
    this.getCharges();
  }
};
</script>
